import { User } from '@apis/index'
import Button from '@components/button'
import Column from '@components/column'
import Fields from '@components/fields'
import Typography from '@components/typography'
import { Formik, Form } from 'formik'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthFooter from '../component/authFooter'
import AuthHeader from '../component/authHeader'
import {
  AuthCard,
  AuthContainer,
  AuthWrapper,
  BottomSection,
  FormContainer,
  FormInputsContainer,
  FormWrapper,
} from '../style'
import GoBack from '@components/back'

const OtpInutResetPassword = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { phoneNo, countryCode, purpose, token } = location.state

  const initialValues = {
    otp: null,
  }

  const [loading, setLoading] = useState(false)

  const sumbitHandler = async (values: any) => {
    setLoading(true)
    const payload = {
      phoneNo: phoneNo,
      otp: values.otp,
      countryCode: countryCode,
      token,
    }
    await User.verifyOtp(payload)
      .then((res) => {
        if (res) {
          navigate('/reset-password', {
            state: {
              ...payload,
              token: res.token,
            },
          })
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }
  const resend = async () => {
    const payload = {
      phoneNo: phoneNo,
      purpose: purpose,
      countryCode: countryCode,
    }
    await User.requestOtp(payload)
      .then((resp) => {
        navigate('.', { state: { ...payload, token: resp.token } })
      })
      .catch(() => {})
  }

  return (
    <AuthWrapper>
      <AuthCard>
        <AuthContainer>
          <GoBack visibleForDesktop={false} />
          <AuthHeader content="OTP" tag="Verification" />

          <Column alignItems="center" rowGap={5} styleColumn="margin:40px auto">
            <Typography
              size={12}
              content="Enter 6 digits code that we've sent to you mobile number"
            />
            <Typography
              size={12}
              content={`+${countryCode} ${phoneNo}`}
              tc={'primary'}
            />
          </Column>

          <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={sumbitHandler}
          >
            {({ handleSubmit }) => {
              return (
                <FormWrapper>
                  <Form onSubmit={handleSubmit}>
                    <FormContainer>
                      <FormInputsContainer>
                        <Fields.OtpInput
                          name="otp"
                          length={6}
                          onResend={resend}
                        />
                      </FormInputsContainer>
                      <BottomSection>
                        <AuthFooter
                          content="Back to Login Page!"
                          tag="Login Now"
                          onClick={() => navigate('/login')}
                        />
                        <Button
                          title="Send OTP"
                          styleButton="width:100%;margin-top:40px;"
                          height={45}
                          type="submit"
                          loading={loading}
                        />
                      </BottomSection>
                    </FormContainer>
                  </Form>
                </FormWrapper>
              )
            }}
          </Formik>
        </AuthContainer>
      </AuthCard>
    </AuthWrapper>
  )
}

export default OtpInutResetPassword
